import { StyleSheet, View } from 'react-native';

import { useCRMEventsContext } from '@fhs/auth/src/hooks';
import { Text, tokens } from '@fhs/ui';
import { LOYALTY_SAVINGS } from '@fhs-legacy/frontend/src/utils/test-ids';

import { logCheckoutDiscountNotApplied } from '../../utils/logging-utils';

import CashSignIcon from './cash-sign-icon';

export default function SavingsWithOffer({
  savings,
  onCheckout = false,
  loadingSavings = false,
}: {
  savings: number;
  onCheckout?: boolean;
  loadingSavings?: boolean;
}) {
  const { logRBIEvent } = useCRMEventsContext();

  if (loadingSavings) {
    return (
      <View
        testID={LOYALTY_SAVINGS}
        style={onCheckout ? styles.checkoutContainer : styles.cartContainer}
        accessibilityRole="text"
        accessibilityLabel="Calculating savings"
        accessibilityLiveRegion="polite"
      >
        <CashSignIcon variant={onCheckout ? 'green' : 'white'} />
        <Text style={onCheckout ? styles.checkoutTextColor : styles.cartTextColor}>
          Calculating savings...
        </Text>
      </View>
    );
  }
  if (savings === 0) {
    logCheckoutDiscountNotApplied(logRBIEvent);
  }

  const savingsAmount = (savings / 100).toFixed(2);

  return (
    <View
      testID={LOYALTY_SAVINGS}
      style={onCheckout ? styles.checkoutContainer : styles.cartContainer}
      accessibilityRole="text"
      accessibilityLabel={`Saving ${savingsAmount} With Firehouse Rewards`}
      accessibilityLiveRegion="polite"
    >
      <CashSignIcon variant={onCheckout ? 'green' : 'white'} />
      <Text style={onCheckout ? styles.checkoutTextColor : styles.cartTextColor}>
        Saving{' '}
        <Text
          weight="semibold"
          style={onCheckout ? styles.checkoutTextColor : styles.cartTextColor}
        >
          ${savingsAmount}{' '}
        </Text>
        With Firehouse Rewards
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  cartContainer: {
    backgroundColor: tokens.colors.$success,
    height: 49,
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkoutContainer: {
    backgroundColor: tokens.colors.$blackOpacity10,
    height: 49,
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 28,
    marginTop: 16,
  },
  cartTextColor: {
    color: 'white',
  },
  checkoutTextColor: {
    color: tokens.colors.$black,
  },
  skeleton: {
    height: 16,
    width: 33,
    borderRadius: 4,
    marginTop: 4,
  },
});
